module.exports = __webpack_public_path__ + "img/logo_postnord.18d13620.png";